import { EQuizMode } from '@constants';
import { ICreateQuizResult } from '@sdk/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sdk } from '@/services';
import { useQuizActivity } from '@/store';

const QuizResultService = sdk.getService('QuizResultService');

export const useMutateQuizResults = () => {
  const queryClient = useQueryClient();
  const { setActivityAsCompleted } = useQuizActivity();

  const onSuccess = () =>
    queryClient.invalidateQueries({
      queryKey: ['quiz-results']
    });

  const { mutate: calculateQuizResults, isPending: isLoading } = useMutation({
    mutationFn: (quizData: ICreateQuizResult) => QuizResultService.calculateQuizResults(quizData),
    onSuccess: ({ studentQuiz }) => {
      onSuccess();
      if (studentQuiz.mode === EQuizMode.QUIZ) setActivityAsCompleted();
    }
  });

  return {
    calculateQuizResults,
    isWorking: isLoading
  };
};
